import { lazy } from 'react';

import { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { appRoutes } from './app/_routes';
import { authRoutes } from './auth/_routes';

const Forbidden = lazy(() => import('./403'));
const NotFound = lazy(() => import('./404'));
const AuthErrorPage = lazy(() => import('./auth/error'));

export const routes: RouteObject[] = [
  ...authRoutes,
  ...appRoutes,
  // Error pages
  { path: '/auth/error', element: <AuthErrorPage /> },
  { path: '/403', element: <Forbidden /> },
  // Fallback
  { path: '/404', element: <NotFound /> },
  { path: '*', element: <Navigate to="/404" replace /> },
];
